import React, { useState, useEffect } from "react";
import {
    Grid,
    Box,
    Typography,
    Container,
    useMediaQuery,
    GridItemsAlignment,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import AvaliableVetListItem from "../../Components/ListItems/AvaliableVet";
import API from "../../helpers/apiHelpers";
import moment from "moment";
import {petTypes, specialities} from "../../Constants/specialities";
import {colorWhite} from "../../Constants/theme";
import Calendar from "../../Components/Calendar";
import {Card, CardContent, TextField} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Title } from "react-admin";
import { timezones } from "../../Constants/timezones";
import {servicesList, reasons} from "../../Constants/serviceType";
import { styles } from "@material-ui/pickers/views/Calendar/Calendar";
import { states } from "../../Constants/locations";
import { useSnackbar } from "notistack";

const useStyle = makeStyles(() => ({
    wrapper: {
        height: "100%",
        marginTop: 20,
        marginBottom: 50,
    },
    doctorList: {
        backgroundColor: colorWhite,
        width: "100%",
        padding: 10,
    },
    avatarPaper: {
        width: 150,
        height: 150
    },
    serviceType: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        width: 200,
        height: 30
    },
    serviceTypeContainer: {
        marginLeft: 40
    },
    servicePay: {
        height: 100,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    selectWidth: {
        height: 60,
        width: 145,
        fontSize: "18px",
        fontFamily: "NotoSerifDisplay"
    },
    avaliableVetRow: {
        marginBottom: 20,
    },
    selectInput: {
        padding: 10,
    }
}));

const AvaliableVetAdmin = () => {
    const classes = useStyle();
    const [vetProfiles, setVetProfiles] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
    let isMobile = useMediaQuery("(min-width:600px)");
    let justifyResonsiveEnd: GridItemsAlignment = isMobile? "flex-end" : "center";
    let justifyResonsiveStart: GridItemsAlignment = isMobile? "flex-start" : "center";
    const [timeZone, setTimeZone] = useState("UTC");
    const [petType, setPetType] = useState<undefined | any>();
    const [vState, setVState] = useState<undefined | any>();
    const [serviceType, setServiceType] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    // const [reasonType, setReasonType] = useState<undefined | any>();
    const { enqueueSnackbar } = useSnackbar();

    const getTimeslotsForSelectedDate = (scheduling, dateTime) => {
        const dateTimeSlots = scheduling.find(item => moment(item.date).isSame(dateTime, "day"));
        return (dateTimeSlots || {timeslots: []}).timeslots;
    };

    const getSchedulingForUserTimezone = (schedule) => {
        let newSchedule = schedule
            .reduce((acc, item) => ([
                ...item.timeslots,
                ...acc,
            ]), [])
            .sort((a,b) => moment(a).diff(moment(b)))
            .map(item => {
                const tz = timeZone;
                const time = moment.tz(item, tz);
                return time;
            })
            .filter(timeslot => timeslot > moment())
            .reduce((acc, item) => {
                let key = item.format("YYYY-MM-DD");
                if (!acc[key]) {
                    acc[key] = {
                        date: key,
                        timeslots: []
                    };
                }
                acc[key].timeslots.push(item.format());
                return acc;
            }, {});
        return Object.values(newSchedule);
    };

    const getVetsForDate = async (day) => {
        setIsLoading(true);
        setSelectedDate(day);
        let reasonType = serviceType.includes("ADVICE") ? "ADVICE&TRIAGE" : "PRESCRIPTION";
        try {
            let param = {
                type: "VET",
                desiredApptType: serviceType,
                clientTimeZone: timeZone,
                rangeBegins: moment(day).format("YYYY-MM-DD"),
                rangeEnds: moment(day).add(1, "days").format("YYYY-MM-DD"),
            };
            if (reasonType === "PRESCRIPTION") {
                Object.assign(param, {
                    workingStates: [vState?.value],
                    prescriptionDesire: true
                });
            }
            const profiles = await API.getProfiles(param);
            setVetProfiles(profiles);
            setIsLoading(false);
        } catch (err) {
            console.error(err);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if(vetProfiles.length) {
            let availableTimeSlots = [];
            vetProfiles.forEach((profile) => {
                const schedulingForUserTimezone = getSchedulingForUserTimezone(profile.schedulingDays);
                const timeslots = getTimeslotsForSelectedDate(schedulingForUserTimezone, selectedDate);
                availableTimeSlots.push(...timeslots);
            });
            (availableTimeSlots.length)? setAvailableTimeSlots(availableTimeSlots) : setAvailableTimeSlots(availableTimeSlots);
        }
    }, [vetProfiles]);

    useEffect(() => {
        (async () => {
            let reasonType = serviceType.includes("PRESCRIPTION") ? "PRESCRIPTION" : "ADVICE&TRIAGE";
            try{
                let specialtyForPet = "";
                let filteredType = specialities.filter(speciality => speciality?.value === petType?.value);
                let params = {
                    type: "VET",
                    specialties: filteredType.length > 0 ? [filteredType[0]?.value] : [specialtyForPet],
                    desiredApptType: serviceType,
                    clientTimeZone: timeZone,
                    rangeBegins: moment(selectedDate).format("YYYY-MM-DD"),
                    rangeEnds: moment(selectedDate).add(1, "days").format("YYYY-MM-DD"),
                };
                if (reasonType === "PRESCRIPTION") {
                    Object.assign(params, {
                        workingStates: [vState?.value],
                        prescriptionDesire: true
                    });
                }
                const profiles = await API.getProfiles(params);
                setVetProfiles(profiles);
            } catch (err) {
                console.error(err);
            }
        })();
    }, [timeZone, petType, serviceType, vState]);

    return (
        <Card>
            <Title title="Available Vets" />
            <CardContent>
                <Grid container spacing={1} className={classes.wrapper}>
                    <Grid container>
                        <Grid item xs={6}>
                            <Autocomplete
                                options={timezones}
                                getOptionLabel={(option) => option}
                                value={timeZone}
                                onChange={(event, value) => {
                                    value ? setTimeZone(value) : setTimeZone("");
                                }}
                                className={classes.selectInput}
                                renderInput={(params) => <TextField {...params} label="Time Zone" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                options={petTypes}
                                getOptionLabel={(option) => option.label}
                                value={petType}
                                onChange={(event, value) => {
                                    value? setPetType(value) : setPetType("");
                                }}
                                className={classes.selectInput}
                                renderInput={(params) => <TextField {...params} label="Pet Type" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                options={servicesList.filter(service => ["ADVICE_CHAT", "ADVICE_VIDEO", "RX_VIDEO"].some(item => item === service))}
                                getOptionLabel={(option) => option}
                                value={serviceType}
                                onChange={(event, value) => {
                                    value ? setServiceType(value) : setServiceType("");
                                }}
                                className={classes.selectInput}
                                renderInput={(params) => <TextField {...params} label="Service" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                options={states}
                                getOptionLabel={(option) => option.label}
                                value={vState}
                                onChange={(event, value) => {
                                    setVState(value);
                                }}
                                className={classes.selectInput}
                                renderInput={(params) => <TextField {...params} label="State" variant="outlined" />}
                            />
                        </Grid>
                    </Grid>
                    <Calendar
                        value={selectedDate || new Date()}
                        handleChange={getVetsForDate}
                        loading={isLoading}
                    />
                    <Grid item xs={12} container justify="center">
                        <Grid item xs={11} container justify="flex-start" style={{marginBottom: 40}}>
                            <Typography variant="h4">{moment(selectedDate).format("dddd, MMMM D, YYYY")}</Typography>
                        </Grid>
                    </Grid>
                    <Box marginBottom="20px" />
                    {
                        (!vetProfiles.length || !availableTimeSlots.length) ?
                            <Grid item xs={12} container justify="center">
                                <Grid item xs={11} container justify="flex-start">
                                    <Typography>No available vets found</Typography>
                                </Grid>
                            </Grid>:
                            vetProfiles.map((profile) => {
                                const schedulingForUserTimezone = getSchedulingForUserTimezone(profile.schedulingDays);
                                const timeslots = getTimeslotsForSelectedDate(schedulingForUserTimezone, selectedDate);
                                return (
                                    <AvaliableVetListItem
                                        name={`Dr. ${profile.lastName || ""}`}
                                        key={profile.id}
                                        profileId={profile.id}
                                        image={profile.image}
                                        userId={profile.userId}
                                        profile={profile}
                                        speciality={profile.speciality}
                                        scheduling={timeslots}
                                        isButtonsDisable={true}
                                    />
                                );
                            })
                    }
                </Grid>
            </CardContent>
        </Card>
    );
};

export default AvaliableVetAdmin;
